import React from "react";

function GercelSayiAraliklariKumeIslemleriIntro() {
  return <div>GercelSayiAraliklariKumeIslemleriIntro</div>;
}

export default GercelSayiAraliklariKumeIslemleriIntro;
